import { InfiniteScroll, printComponent, Progress } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import MonetizationApproverPresenter from "./MonetizationApproverPresenter";
import CardView from "../../../../components/common/CardView";
import DateRangePicker from "../../../../components/common/DateRangePicker";
import Search from "../../../../components/Search";
import Table from "../../../../components/Table";
import withRouter from "../../../../withRouter";
import HRMSPrintMonetization from "../LeaveApprover/HRMSPrintMonetization";
import React from "react";
import InputFactory from "../../../../components/InputFactory";

class MonetizationApproverPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new MonetizationApproverPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      status: [],
      filteredStatus: "",
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
    this.contractPDF = React.createRef();
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const status = await findObjectUseCase().execute("monetization_request");
    this.setState({ status });
  }

  getCollectionName() {
    return "monetization_request";
  }

  // delete function
  async handleDeleteData(id) {
    await this.presenter.deleteObjectUseCase.execute(
      "monetization_request",
      id
    );
    this.refetchData();
  }

  // edit function
  async handleEditData(obj) {
    this.navigateTo(`/approve/${this.getCollectionName()}/${obj.id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onChangeOption(field, value) {
    this.setState({ [field]: value });
    if (field === "filteredStatus") {
      this.onChangeFilter("String", value, "stats");
    }
  }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  getcurrent() {
    return this.getCurrentUser().employee;
  }

  async handlePrintData(data) {
    const [vacationLeave, sickLeave] = await Promise.all([
      findObjectUseCase().execute("leave_cred", {
        where: { empID: data?.employee?.id, type: "Vacation Leave" },
      }),
      findObjectUseCase().execute("leave_cred", {
        where: { empID: data?.employee?.id, type: "Sick Leave" },
      }),
    ]);

    this.setState({ object: data, vacationLeave, sickLeave });
    printComponent(this.contractPDF.current, "Tasks");
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div className="d-none">
          <div ref={this.contractPDF} id="contractPDF">
            <HRMSPrintMonetization
              object={this.state.object}
              vacationLeave={this.state.vacationLeave}
              sickLeave={this.state.sickLeave}
            />
          </div>
        </div>

        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="">
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  <div className="col-md-6 d-flex mt-1">
                    {Object.keys(schema.filters || {}).map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <InputFactory
                          key={field}
                          className="ms-1"
                          type={type}
                          field={field}
                          where={{}}
                          onChange={this.onChangeFilter.bind(this, type)}
                          {...options}
                        />
                      );
                    })}
                  </div>
                  <div className="col-md-3 mt-1">
                    <DateRangePicker
                      fields={["createdAt", "updatedAt", "employee.id"]}
                      onFilter={(filterObj) => {
                        // this.searchSubmit(filterObj);
                        if (Object.keys(filterObj).length > 0) {
                          const updatedAtDate = new Date(
                            filterObj.updatedAt.$lte
                          );
                          updatedAtDate.setDate(updatedAtDate.getDate() + 1);

                          const updatedFilterObj = {
                            ...filterObj,
                            updatedAt: {
                              $lte: updatedAtDate.toISOString().split("T")[0],
                            },
                          };
                          this.searchSubmit(updatedFilterObj);
                        } else {
                          this.searchSubmit(filterObj);
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-3 mt-1">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                </div>
              </CardView>
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                  </div>
                </CardView>
              </div>

              <Table
                // objectId={this.handleDeleteData.bind(this)}
                progress={loading}
                objectData={this.handleEditData.bind(this)}
                objectDataDis={(data) => this.handlePrintData(data)}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-pencil-square"> Edit</i>,
                    actionType: "object",
                  },
                  {
                    label: <i className="bi bi-printer"> Print</i>,
                    actionType: "objectDis",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "updatedAt", "supervisor"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(MonetizationApproverPage);
